const getErrorMessage = (factory, node, staticContext) => {
  return typeof factory === "string" ? factory : factory(node, staticContext);
};
export {
  getErrorMessage
};
//# sourceMappingURL=getErrorMessage.js.map
